// extracted by css-extract-rspack-plugin
export default {"root":"o8CwO"};